(() => {
  const SEL =
    '.gw-rd-earn-points-product-page-widget, .gw-rd-earn-points-product-page-widget-placeholder';

  let syncing = false;
  let scheduled = null;

  const harden = (el) => {
    if (!el || el.nodeType !== 1) return;
    if (el.style.paddingBottom === '0px' && el.dataset.ysfEarnHardened === '1') {
      return;
    }
    el.dataset.ysfEarnHardened = '1';
    el.style.setProperty('padding-bottom', '0', 'important');
    el.style.setProperty('padding-block-end', '0', 'important');
    el.style.setProperty('padding-top', '2px', 'important');
    el.style.setProperty('padding-right', '5px', 'important');
    el.style.setProperty('padding-left', '0', 'important');
    el.style.setProperty('margin-bottom', '8px', 'important');
    el.style.setProperty('line-height', '1', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('height', 'fit-content', 'important');
    el.querySelectorAll('*').forEach((child) => {
      child.style.setProperty('padding-bottom', '0', 'important');
      child.style.setProperty('padding-block-end', '0', 'important');
      child.style.setProperty('margin-bottom', '0', 'important');
      child.style.setProperty('line-height', '1', 'important');
    });
  };

  const sync = () => {
    if (syncing) return;
    syncing = true;
    try {
      document.querySelectorAll(SEL).forEach(harden);
    } finally {
      syncing = false;
    }
  };

  const schedule = () => {
    if (syncing || scheduled) return;
    scheduled = requestAnimationFrame(() => {
      scheduled = null;
      sync();
    });
  };

  const observe = () => {
    document.querySelectorAll('.ysf-earn-points, .product-info').forEach((root) => {
      if (root.dataset.ysfEarnObserved === '1') return;
      root.dataset.ysfEarnObserved = '1';
      new MutationObserver(() => {
        if (!syncing) schedule();
      }).observe(root, {
        childList: true,
        subtree: true,
        attributes: false,
      });
    });
  };

  const init = () => {
    observe();
    sync();
    [300, 1000, 2500].forEach((ms) => setTimeout(sync, ms));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
